const middleware = {}

middleware['referral'] = require('../middleware/referral.js')
middleware['referral'] = middleware['referral'].default || middleware['referral']

export default middleware
